import React from 'react';
import { Cancel } from '@mui/icons-material';

interface DisconnectConfirmationModalProps {
  isOpen: boolean;
  integrationName: string;
  onClose: () => void;
  onConfirm: () => void;
}

const DisconnectConfirmationModal: React.FC<DisconnectConfirmationModalProps> = ({
  isOpen,
  integrationName,
  onClose,
  onConfirm
}) => {
  return (
    <div className={`fixed inset-0 z-[60] ${isOpen ? "flex" : "hidden"} items-start justify-center p-6`}>
      <div className="fixed inset-0 bg-white bg-opacity-90 z-40" onClick={onClose}></div>
      <dialog
        data-testid="disconnect-confirmation-modal"
        className="z-50 w-full max-w-md max-h-[95vh] bg-[#fff] relative rounded-xl shadow-[#00000029] shadow-[0_0px_8px_rgba(0,0,0,0.16)] overflow-hidden flex flex-col"
        open={isOpen}
        onClose={onClose}
        style={{ margin: 0 }}
      >
        <div className="overflow-y-auto flex-1 p-6">
          <span onClick={onClose} className="ml-auto w-full flex cursor-pointer mb-4">
            <Cancel className="text-[#A1A1A1] hover:text-[#777] h-[18px] w-[18px] ml-auto" />
          </span>
          
          <div className="flex flex-col w-full">
            <h1 className="text-[24px] text-black font-bold font-raleway mb-4">
              Disconnect {integrationName}?
            </h1>
            
            <div className="text-[16px] w-full text-[#333333] my-2 font-open-sans mb-6">
              Are you sure you want to disconnect {integrationName}? This will stop all data synchronization and you'll need to reconnect to use this integration again.
            </div>
            
            <div className="flex flex-row justify-between w-full gap-x-3 my-2">
              <button
                className="w-1/2 h-10 font-raleway font-semibold text-center text-[#333333] bg-white border-[#E9E9E9] border-[1px] rounded-md hover:bg-gray-50 transition-colors"
                onClick={onClose}
              >
                Cancel
              </button>
              <button
                className="w-1/2 h-10 text-center text-white bg-[#D42620] rounded-md font-raleway font-semibold hover:bg-[#B01E1A] transition-colors"
                onClick={onConfirm}
                data-testid="disconnect-confirm-button"
              >
                Disconnect
              </button>
            </div>
          </div>
        </div>
      </dialog>
    </div>
  );
};

export default DisconnectConfirmationModal;

